import styled, { css } from 'styled-components';
import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';
import statusMapIcon_gas_warning from 'static/images/icon/statusMapIcon_gas_warning.png';
import statusMapIcon_gas_danger from 'static/images/icon/statusMapIcon_gas_danger.png';
import statusMapIcon_gas_none from 'static/images/icon/statusMapIcon_gas_none.png';

export const AreaContainer = styled.div`
  width: 80px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;

  ${(props) =>
    css`
      left: ${props.xcoordinate - 25}px;
      top: ${props.ycoordinate - 25}px;
    `}

  & > div.titleNum {
    position: absolute;
    left: 0px;
    top: 35px;
    width: 80px;
    align-items: center;
    font-size: 17px;
  }

  @keyframes hideshow {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    51% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  & > svg {
    color: rgb(255, 0, 0);
    width: 30px;
    height: 30px;
    z-index: 10;
    position: absolute;
    top: -24px;
    left: 9px;
    stroke: #410b0b;
    stroke-width: 1px;
    animation: hideshow 1.5s ease infinite;
  }

  .areaBox {
    position: relative;

    .areaName {
      position: absolute;
      top: 40px;
      left: -75px;
      width: 200px;
      color: #fff;

      p {
        width: fit-content;
        margin: auto;
        padding: 0 10px;
        font-size: 12px;
        background: #1f242c;
      }
    }

    .modules {
      position: absolute;
      background: #123456;
      color: #fff;
      top: 50px;
      left: -105px;
      width: 300px;
      display: none;
      z-index: 9;

      div:hover {
        cursor: pointer;
        background: #07192c;
      }
    }

    .viewOn {
      display: block;
    }
  }

  @keyframes alertShow {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(2);
    }
  }

  img.alert-animation {
    position: absolute;

    ${(props) =>
      props.alertAnimationOn
        ? css`
            animation: alertShow 1.5s ease infinite;
          `
        : css`
            display: none;
          `}
  }

  @keyframes hideshow {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    51% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  img.statusicon {
    width: 30px;
    height: 30px;
    z-index: 10;
    top: -24px;
    left: 40px;
    position: absolute;
    animation: hideshow 1.5s ease infinite;
  }

  img.moduleicon-hide-animation {
    ${(props) =>
      props.alertAnimationOn &&
      css`
        animation: hideshow 1.5s ease infinite;
      `}
  }

  img.moduleicon {
    width: 80px;
    height: 80px;

    ${(props) =>
      props.scn === '0' &&
      (props.status === 'danger'
        ? css`
            content: url(${statusMapIcon_gas_danger});
          `
        : props.status === 'warning'
        ? css`
            content: url(${statusMapIcon_gas_warning});
          `
        : props.status === 'none'
        ? css`
            content: url(${statusMapIcon_gas_none});
          `
        : css`
            content: url(${statusMapIcon_gas_blue});
          `)}
  }
`;
